
































































































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import DeliveryPrepare from '@/components/order/mixins/DeliveryPrepare';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

import {Component, Mixins, Ref, Watch} from 'vue-property-decorator';
import {
  PutOrderOptionHoldDeliveryRequest,
  PutShippingsAssignInvoicesRequest,
  GetDeliveryCompaniesRequest,
  OrderStatusType,
  NaverpayConfigs
} from 'supporter';
import { i18nObjectByKey} from '@/utils/i18n';
import {ncpPopup} from '@/utils/ncp';
import {getCookie, setCookie, deleteCookie} from '@/utils/cookieUtils';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import $ from 'jquery';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';

@Component({
  components: {OrderContentTop, PageTitle, ItemTable, CompSelectBox}
})
export default class OrderDeliveryPrepare extends Mixins(DeliveryPrepare, OrderGridBrokenFreeGiftMixin) {
  @Ref('gridBottom') protected readonly gridRef: ItemTable;
  private orderListContent: any = [];
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private initColums: any[] = [];
  private deliveryCompanyType = '';

  private request: any = {
    params: {}
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private exchangeMemberData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_PRODUCT_PREPARE_MEMBER_GROUP_PUPOP_TITLE',
    nonFooter: false,
    hasConfirmBtn: false
  };
  public tabProductList: boolean = true;
  private mallNo: any = null;
  public deliveryCompanyTypeArr: any[] = [];
  private initSearchDateTypeArr: any[] = [];
  private groupByKey: any = 'DELIVERYNO';
  private naverConfig: NaverpayConfigs | null = null;
  private showNaverPayDelayButton = false;

  @Watch('tabProductList', {immediate: false, deep: true})
  tabProductListChange(): any {
  }

  resetNaverConfig(){
    this.fetchNaverPayConfig()
  }

  public ifExchange: boolean = false;
  private exchangeHelpData: any = {
    id: 'exchangeHelp',
    width: 500,
    title: 'ORDER_LIST_GRIDS_PAY_DONE_LAYER_TITLE',
    nonFooter: true
  };
  private contentBottomOption: any = {
    name: 'deliveryPrepare',
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {}
    },
    excelKey: this.tabProductList ? 'PREMIUM_DELIVERY_PREPARE_BY_DELIVERY_NO' : 'PREMIUM_DELIVERY_PREPARE_BY_ORDER_NO'
  };

  private created(): void {
    this.initSearchDateType();
    this.exchangeHelpData = i18nObjectByKey(this, this.exchangeHelpData, 'title');
    this.exchangeMemberData = i18nObjectByKey(this, this.exchangeMemberData, 'title');
    this.initTab();
  }
  private destroyed(): void {
    deleteCookie('orderDeliveryPrepareTab');
    $('body').off('change', '.invoiceNoInput', $.proxy(this.handleInvoiceNoChange, this));
    $('body').off('keyup', '.invoiceNoInput', $.proxy(this.handleInvoiceNoKeyup, this));
    $('body').off('keydown', '.invoiceNoInput', $.proxy(this.handleInputeKeyDown, this));
    $('body').off('mousedown', '.invoiceNoInput[disabled]', $.proxy(this.handleDisabledMouseDown, this));
    $('body').off(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => (this.ifExchange = true), this)
    );
    $('body').off(
      'click',
      '.tui-grid-content-area input[name="_checked"]',
      $.proxy(this.checkGroupRow, this)
    );
    $('body').off('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').off('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
  }
  private mounted(): void {
    $('body').on(
      'click',
      '#exchangeHelpBtn',
      $.proxy(() => (this.ifExchange = true), this)
    );
    $('body').on(
      'click',
      '.tui-grid-content-area input[name="_checked"]',
      $.proxy(this.checkGroupRow, this)
    );
    this.getDeliveryCompanies();
    $('body').on('change', '.invoiceNoInput', $.proxy(this.handleInvoiceNoChange, this));
    $('body').on('keyup', '.invoiceNoInput', $.proxy(this.handleInvoiceNoKeyup, this));
    $('body').on('keydown', '.invoiceNoInput', $.proxy(this.handleInputeKeyDown, this));
    $('body').on('mousedown', '.invoiceNoInput[disabled]', $.proxy(this.handleDisabledMouseDown, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    if(!getCookie('orderDeliveryPrepareTab')) {
      setCookie('orderDeliveryPrepareTab', 'true');
    }
    this.fetchNaverPayConfig();
  }
  private initTab(): void {
    if (!this.$route.query.fromMain && getCookie('orderDeliveryPrepareTab') === 'false') {
      this.tabProductList = false;
    }
    if (this.tabProductList) {
      this.groupByKey = 'DELIVERYNO';
    } else {
      this.groupByKey = 'ORDERNO';
    }
  }
  private initSearchDateType(): void {
    this.initSearchDateTypeArr = [
      {value: 'STATE_CHANGE_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_LIST_STATE_CHANGE_YMDT_1'},
      {value: 'ORDER_YMDT', name: 'ORDER_ORDER_CONTENT_TOP_LIST_ORDER_YMDT'}
    ];
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse($(e.target).data('json').replace(/\\\"/g, '"'));
    this.showMemberGroup = true;
  }
  private handleDisabledMouseDown(): any {
    return false;
  }
  private contains(str: any, startIndex: any): any {
    return str.indexOf(startIndex) !== -1;
  }
  private handleInputeKeyDown(e: any): void {
    // Allow: backspace, delete, tab, escape, enter, - and .
    if (
      this.contains([46, 8, 9, 27, 13, 110], e.keyCode) ||
      // Allow: Ctrl + A/X/V/C
      e.ctrlKey === true ||
      // Allow: home, end, left, right, down, up
      (e.keyCode >= 35 && e.keyCode <= 40)
    ) {
      // let it happen, don't do anything
      return;
    }
    // 允许英文大小写
    if ((e.keyCode > 64 && e.keyCode < 91) || (e.keyCode > 96 && e.keyCode < 123)) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }
  private handleInvoiceNoKeyup(ev: any): void {
    const rowKey: any = Number(ev.target.dataset.rowKey);
    const value = ev.target.value.replace(/[^0-9a-zA-Z]/g, '');
    $('.invoiceNoInput').filter(`[data-row-key="${rowKey}"]`).val(value);
  }
  private handleInvoiceNoChange(ev: any): void {
    const rowKey: any = Number(ev.target.dataset.rowKey);
    const columnName = ev.target.dataset.columnName;
    const value = ev.target.value.replace(/[^0-9a-zA-Z]/g, '');

    this.setTheValue(rowKey, columnName, value);
    this.orderListContent.forEach((item: any): any => {
      if (item.shippingNo === Number(ev.target.dataset.groupKey)) {
        this.checks(item.rowKey);
        item.invoiceNo = value;
      }
    });
  }
  private gridMouseDown(ev: any): any {
    const elem = ev.nativeEvent.target;
    if (elem.tagName === 'INPUT') {
      elem.focus();
    }
    return false;
  }
  private handleCompanySelect(e: any): void {
    e.preventDefault();
    this.orderListContent.forEach((item: any): any => {
      if (item.shippingNo === Number(e.target.dataset.groupKey)) {
        this.checks(item.rowKey);
        item.deliveryCompanyType = e.target.value;
        this.setTheValue(item.rowKey, 'deliveryCompanyType', e.target.value);
      }
    });
  }
  private getDeliveryCompanies(): void {
    let request: GetDeliveryCompaniesRequest = {
      params: {
        countryCd: 'KR'
      }
    };
    this.$api.getDeliveryCompanies(request).then((res): any => {
      this.deliveryCompanyTypeArr = [...res.data];
      if (this.deliveryCompanyTypeArr.length > 0) {
        this.deliveryCompanyType = this.deliveryCompanyTypeArr[0].deliveryCompanyType;
      }
      $('body').on('change', '.companySelect', $.proxy(this.handleCompanySelect, this));
    });
  }

  private handleTabChange(groupByKey: 'DELIVERYNO' | 'ORDERNO'): void {
    this.tabProductList = !this.tabProductList;
    this.groupByKey = groupByKey;
    let theTop: any = this.$refs.orderContentTop;
    if (groupByKey === 'DELIVERYNO') {
      setCookie('orderDeliveryPrepareTab', 'true');
      this.contentBottomOption.excelKey = 'PREMIUM_DELIVERY_PREPARE_BY_DELIVERY_NO'
    } else {
      setCookie('orderDeliveryPrepareTab', 'false');
      this.contentBottomOption.excelKey = 'PREMIUM_DELIVERY_PREPARE_BY_ORDER_NO'
    }

    theTop.handleSearch();

    this.$nextTick((): any => {
      theTop.handleSearchTypeArr();
    });
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
  }
  private initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if(item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.columns['ordererContact1'] = this.$t('ORDER_LIST_GRIDS_ORDER_CONTACT1_HEADER_NO_SPACE');
    this.contentBottomOption.excelDownInfo.columns['displayOptionName'] = this.$t('ORDER_LIST_GRIDS_ORDER_DISPLAY_OPTION_NAME_NO_SPACE');
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_shipment_processing_';
  }

  @Watch('groupByKey')
  private changeGroupByKey() {
    this.search();
  }

  private handleSearch(e: any, delay: boolean, page: number = 1): void {
    this.request = {
      params: {}
    };
    this.$set(this.request, 'params', e);
    this.request.params.orderStatusType = 'DELIVERY_PREPARE';
    this.request.params.partnerNo = Number(e.partnerNo);
    if (e.delay === true) {
      this.request.params.delay = false;
      this.request.params.naverDeliveryDelay = true; // 이걸 상위 스코프로 추출하면 e.delay 가 false로 나옴, 대체 무슨 마법인지 모르겠음
    } else {
      this.request.params.delay = false;
      this.request.params.naverDeliveryDelay = false; // 이걸 상위 스코프로 추출하면 e.delay 가 false로 나옴, 대체 무슨 마법인지 모르겠음
    }
    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    this.request.params.includeHoldDelivery = false;
    $('#loading').show();

    const apiMap = {
      DELIVERYNO: () => this.$api.getOrderOptionsDeliveryGrid(this.request),
      ORDERNO: () => this.$api.getOrderOptionsOrderGrid(this.request),
    }

    // 전 이렇게 작성하고 싶지 않았습니다.
    // 클릭한 탭을 저장한 this.groupByKey가 렌더링 타이밍에 맞지 않게 변경되서 nexttick
    this.$nextTick(() =>{
      apiMap[this.groupByKey]()
        .then((res: any) => {
          this.setGridProps(res, page);
        })
        .finally(() => {
          $('#loading').hide();
          this.$eventBus.$emit('UPDATE-COLUMN-CONFIG');
        });
    })
  }
  private handleCancel(): void {}

  private handleInvoiceFormat(): void {
    let title: any = this.$t('ORDER_DELIVERY_PREPARE_INVOICE_FORMAT_TITLE');
    ncpPopup('/delivery/invoiceFormat/release', title, 1024, 500);
  }
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.orderStatusType = 'DELIVERY_PREPARE';
    this.request.params.page = page;
    this.request.params.size = this.size;
    this.request.params.includeHoldDelivery = false;
    $('#loading').show();

    const apiMap = {
      DELIVERYNO: () => this.$api.getOrderOptionsDeliveryGrid(this.request),
      ORDERNO: () => this.$api.getOrderOptionsOrderGrid(this.request),
    }

    // 기존 코드가 클릭한 탭을 저장한 this.groupByKey가 렌더링 타이밍에 맞지 않게 변경되서 nexttick
    this.$nextTick(()=>{
      apiMap[this.groupByKey]()
        .then((res: any) => {
          this.setGridProps(res, page);
        })
        .finally(() => {
          $('#loading').hide();
          this.$eventBus.$emit('UPDATE-COLUMN-CONFIG');
        });
    });
  }

  private setGridProps(res: any, page: number){
    this.orderListContent = [];
    let content: any = res.data.contents;
    if (res.data.contents.length > 0) {

	    const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		    small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	    }

      if (this.tabProductList) {
        this.orderListContent = [...this.formatterList(content, 'deliveryOrderGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
        let bigRow = [
          'shippingNo',
          'deliveryMemo',
          'receiverName',
          'receiverContact1',
          'receiverZipCd',
          'address',
          'customsIdNumber',
          'deliveryType',
          'deliveryCompanyType',
          'invoiceNo',
          'procBtn',
          'deliveryAmtInAdvanceYn',
          'remoteDeliveryAmt',
          'orderRegisterType',
          'reservation',
          'memberGroupInfoJson',
          'procEachBtn',
          'deliveryAmt',
          'adjustedAmt',
          'lastSubPayAmt',
          'lastMainPayAmt',
        ];
        let midRow = ['mallNo', 'payType', 'platformType', 'orderNo', 'ordererName', 'ordererContact1', 'memberNo'];
        let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];
        this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'shippingNo', 'orderNo', 'mallProductNo', customGroupFlagCallbackInfo)];
      } else {
        this.orderListContent = [...this.formatterList(content, 'orderDeliveryGridDatas', 'orderProductGridDatas', 'orderProductOptionGridDatas')];
        let bigRow = [
          'platformType',
          'mallNo',
          'orderRegisterType',
          'reservation',
          'memberGroupInfoJson',
          'payType',
          'ordererName',
          'ordererContact1',
          'memberNo',
          'procEachBtn',
          'shippingNo',
          'lastSubPayAmt',
          'lastMainPayAmt',
        ];
        let midRow = [
          'orderNo',
          'deliveryMemo',
          'receiverName',
          'receiverContact1',
          'receiverZipCd',
          'address',
          'customsIdNumber',
          'deliveryType',
          'deliveryCompanyType',
          'invoiceNo',
          'deliveryAmtInAdvanceYn',
          'adjustedAmt',
          'deliveryAmt',
          'remoteDeliveryAmt'
        ];
        let smallRow: any[] = ['shippingAreaType', 'partnerNo', 'hsCode', 'mallProductNo', 'productManagementCd', 'productName', 'productNameEn'];

	      const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
		      small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
	      }

        this.orderListContent = [...this.meargeRow(this.orderListContent, bigRow, midRow, smallRow, 'shippingNo', 'orderNo', 'mallProductNo', customGroupFlagCallbackInfo)];
      }
    }
    this.setCommunicateFailBgColor(this.orderListContent, this.$refs.gridBottom);
    this.totalCount = res.data.totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
  }

// LINK: src/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue
  protected changeOrderStatus(items, nextOrderStatus) {
    for (let i = 0; i < items.length; i++) {
      items[i].invoiceNo = items[i].invoiceNo; // 이거 왜 이러는지 모르겠는데, 추측하기로 기존 객체에 없는 데이터 세팅하려고 한 듯?
    }
    this.changeStatusProc(nextOrderStatus, [ ...items ], false, this.gridRef, 'DELIVERY_PREPARE', this.search);
  }

  private checkGroupRow(ev: any): void {
    if (this.tabProductList === false) {
      return;
    }
    let beforeCheck = this.getCheckedRowKeys();

    setTimeout(() => {
      this.$nextTick(() => {
        let afterRow = this.getCheckedRowKeys();

        let checkRow: any = [];
        if (ev.currentTarget.checked) {
          checkRow = afterRow.filter((item: any): any => {
            if (beforeCheck.length === 0) {
              return item;
            } else {
              if (beforeCheck.indexOf(item) < 0) {
                return item;
              }
            }
          });
        } else {
          checkRow = beforeCheck.filter((item: any): any => {
            if (afterRow.indexOf(item) < 0) {
              return item;
            }
          });
        }
        let row: any = [];
        checkRow.map((cr: any): any => {
          row.push(this.getRowItems(cr));
        });

        row.forEach((item1: any): any => {
          this.orderListContent.forEach((item2: any): any => {
            if (item2.shippingNo === item1.shippingNo) {
              if (ev.currentTarget.checked) {
                this.checks(item2.orderProductOptionNo);
              } else {
                this.uncheck(item2.orderProductOptionNo);
              }
            }
          });
        });
      });
    }, 0);
  }
  private setTheValue(rowKey: any, columnName: any, value: any): any {
    return (this.$refs.gridBottom as any).setTheValue(rowKey, columnName, value);
  }
  private getCheckedRowKeys(): any {
    return (this.$refs.gridBottom as any).getCheckedRowKeys();
  }
  private getCheckedRows(): any {
    return (this.$refs.gridBottom as any).getCheckedRows();
  }
  private checks(rowKey: any): any {
    return (this.$refs.gridBottom as any).check(rowKey);
  }
  private uncheck(rowKey: any): any {
    return (this.$refs.gridBottom as any).uncheck(rowKey);
  }
  private getRowItems(rowKey: any): any {
    return (this.$refs.gridBottom as any).getRowItems(rowKey);
  }
  private getCheckedItems(arr: any): any {
    return (this.$refs.gridBottom as any).getCheckedItems(arr);
  }
  private getElement(rowKey: any, columnName: any): any {
    return (this.$refs.gridBottom as any).getElement(rowKey, columnName);
  }
  private resetData(data: any, options?: any): any {
    return (this.$refs.gridBottom as any).resetData(data, options);
  }

  private changeStatus(type: OrderStatusType): void {
    if (this.getCheckedRowKeys().length === 0) {
      if (type === 'PAY_DONE') {
        alert(this.$t('ORDER_LIST_GRIDS_DEPOSIT_NOT_CHECK_ROW_ALERT'));
      } else {
        alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      }
      return;
    }

    const checkList: any = this.getCheckedRows();

		const hasFreeGiftConditionBroken = checkList.some(({ freeGiftConditionBrokenType }) => freeGiftConditionBrokenType === 'CLAIM_DONE');
		if (hasFreeGiftConditionBroken) {
			if (!confirm(this.$t('ORDER_LIST_GRIDS_CONFIRM_TO_DELIVERY_OF_FREE_GIFT_BROKEN') as string)) return;
		} else {
			if (!confirm(this.$t('ORDER_LIST_GRIDS_CONFIRM_HANDLE_CHANGE') as string)) return;
		}

    if (this.checkHasEscrowAndInvoiceEmpty(checkList) && type !== 'PRODUCT_PREPARE') {
      alert(this.$t('ORDER_LIST_GRIDS_ESCROW_INVOICE_ALERT_MESSAGE'));
      return;
    }

    this.changeStatusProc(type, checkList, true, this.$refs.gridBottom, 'DELIVERY_PREPARE', this.search);
  }

  // getCheckedRows가 any라서 any 타이핑
  private checkHasEscrowAndInvoiceEmpty(checkList: any): boolean {
    const hasEscrow = checkList.some(checkedItem => checkedItem.payType.includes('ESCROW'));
    if (!hasEscrow) {
      return false;
    }

    const escrowOrders = checkList.filter(checkedItem => checkedItem.payType.includes('ESCROW'));
    const isInvoiceEmpty = escrowOrders.some(escrowOrder => escrowOrder.invoiceNo.trim().length === 0);

    if (!isInvoiceEmpty) {
      return false;
    }

    return true;
  }

  private handlePutDelivery(orderStatusType: OrderStatusType): void {
    let checkedRowList = (this.$refs.gridBottom as any).getCheckedRows().map((row: any) => row.orderProductOptionNo);
    if (checkedRowList.length === 0) {
      alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      return;
    }

    const hasNaverPay = (this.$refs.gridBottom as any).getCheckedRows().some(checkedRow => checkedRow.payType === 'NAVER_PAY')
    if(orderStatusType === 'DELIVERY_PREPARE' && hasNaverPay){
      alert(this.$t('ORDER_ORDER_CONTENT_TOP_NAVER_PAY_HOLD_ALERT'));
      return
    }

    const checkList: any = this.getCheckedRowKeys();
    const flag = checkList.map((row: any): any => this.getRowItems(row).taskMessage).every((value: any): any => value === false);
    let message: any = '';
    const nextAction = orderStatusType == 'DELIVERY_PREPARE' ? this.$t('ORDER_LIST_GRIDS_DELIVERY_TAG') : this.$t('ORDER_LIST_GRIDS_OUT_STORE_TAG');
    if (!flag) {
      message = this.$t('ORDER_LIST_GRIDS_PRODUCT_PREPARE_CHANGE_STATUS_CONFIR_1', {str: nextAction});
    } else {
      message = this.$t('ORDER_LIST_GRIDS_PRODUCT_PREPARE_CHANGE_STATUS_CONFIRM_2', {str: nextAction});
    }

    if (!confirm(message)) {
      return;
    }
    let holdDeliveryRequest: PutOrderOptionHoldDeliveryRequest = {
      params: {
        orderOptionNos: checkedRowList.join(',')
      },
      data: {}
    };
    this.$api.putOrderOptionHoldDelivery(holdDeliveryRequest).then((): any => {
      alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
      this.search(1, this.size);
    });
  }
  private handlePutShippings(): void {
    if (this.getCheckedRowKeys().length === 0) {
      alert(this.$t('ORDER_LIST_GRIDS_NOT_CHECK_ROW_ALERT'));
      return;
    }
    const checkedRowList = this.getCheckedRows();
    let hasInvoiceInfos = true;
    let isParcelDelivery = true;
    $.each(checkedRowList, (index, value) => {
      if (!value.deliveryCompanyType) {

        // 기존 코드는 merge 되기전 deliveryCompanyType를 가져오도록 코딩되어있었는데, 불가능해서 이전 인덱스의 shippingNo를 비교해 같은 배송번호일때 deliveryCompanyType 가져오도록 변경
        if(index !== 0 && (checkedRowList[Number(index)-1].shippingNo === checkedRowList[index].shippingNo)){
          value.deliveryCompanyType = checkedRowList[Number(index)-1].deliveryCompanyType
          return
        }

        value.deliveryCompanyType = $((this.$refs.gridBottom as any).getElement(value.rowKey, 'deliveryCompanyType'))
          .find('select')
          .val();
      }
      if (value.deliveryType === 'PARCEL_DELIVERY' && value.delivery === true && (this.isEmpty(value.deliveryCompanyType) || this.isEmpty(value.invoiceNo))) {
        hasInvoiceInfos = false;
      } else if (value.deliveryType !== 'PARCEL_DELIVERY') {
        isParcelDelivery = false;
      }
    });

    if (!hasInvoiceInfos) {
      alert(this.$t('ORDER_LIST_GRIDS_INVOICE_NO_EMPTY_ALERT'));

      return;
    }
    if (!isParcelDelivery) {
      alert(this.$t('ORDER_DELIVERY_PREPARE_IS_PARCEL_DELIVERY_ALERT'));

      return;
    }

    if (!confirm(this.$t('ORDER_DELIVERY_PREPARE_DO_DELIVERY_CONFIRM') as string)) {
      return;
    }
    const theOption = this.getCheckedItems(['shippingNo', 'deliveryCompanyType', 'invoiceNo']);
    theOption.map((data) => {
      if(data.deliveryCompanyType === null) {
        data.deliveryCompanyType = 'CJ';
      }
    });
    let request: PutShippingsAssignInvoicesRequest = {
      data: {
        requestChannelType: 'SERVICE',
        releaseYn: 'N',
        invoices: theOption
      }
    };
    this.$api.putShippingsAssignInvoices(request).then(() => {
      alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
    });
  }

  private async onNaverDelayProcess(){
    let checkedRows = (this.$refs.gridBottom as any).getCheckedRows();

    if(!this.validateNaverDelay(checkedRows)){
      return
    }
    const selectedOrderProductOptionNo = checkedRows.map(checkedRow => checkedRow.orderProductOptionNo).toString()

    await this.$api.getNaverPayValidDelayProductOrder({params: {orderOptionNos: selectedOrderProductOptionNo}})

    ncpPopup(`/order/delayProductOrderPopup?orderProductOptionNos=${selectedOrderProductOptionNo}`, '네이버페이 발송지연 처리', 800, 700);
  }

  private validateNaverDelay(checkedRows){
    if(checkedRows.length === 0){
      alert(this.$t('ORDER_LIST_GRIDS_PAY_DONE_NOT_CHECK_ROW_ALERT'));
      return false;
    }

    const isAllNaverPay = checkedRows.every(row => row.payType === 'NAVER_PAY')
    if(!isAllNaverPay){
      alert(this.$t('네이버페이 주문형 주문만 처리 가능합니다.'))
      return false;
    }

    return true;

  }

  private async fetchNaverPayConfig(){
    const selectedMallNo = (this.$refs.orderContentTop as any).selectMall?.mallNo;

    if(!selectedMallNo){
      this.showNaverPayDelayButton = false;
      return
    }

    const {data} = await this.$api.getOrderConfigsNaverpay({params: {mallNo: selectedMallNo}})
    this.naverConfig = {...data} as any;
    this.showNaverPayDelayButton = this.naverConfig.enables;
  }
}
